import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { BiUpArrowAlt, BiDownArrowAlt } from 'react-icons/bi';

function Table(props) {
	const { columns, data, paginationNotRequired } = props;
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		// rows,
		page,
		prepareRow,
		gotoPage,
		canPreviousPage,
		previousPage,
		nextPage,
		canNextPage,
		pageOptions,
		pageCount,
		state: {
			pageIndex,
			//pageSize
		},
	} = useTable(
		{
			columns,
			data,
			initialState: {
				pageSize: 6,
				pageIndex: 0,
			},
		},
		useSortBy,
		usePagination
	);

	return (
		<>
			<div
				style={{
					overflowX: 'auto',
					width: '100%',
					height: props.tableHeight,
					overflowY: 'auto',
				}}>
				<table className='table' {...getTableProps()}>
					<thead>
						{headerGroups.map((headerGroup) => (
							<tr {...headerGroup.getHeaderGroupProps()}>
								{headerGroup.headers.map((column) => (
									<th
										width={column.width}
										{...column.getHeaderProps(column.getSortByToggleProps())}>
										{column.render('Header')}
										<span>
											{column.isSorted ? (
												column.isSortedDesc ? (
													<BiUpArrowAlt />
												) : (
													<BiDownArrowAlt />
												)
											) : (
												<BiUpArrowAlt />
											)}
										</span>
									</th>
								))}
							</tr>
						))}
					</thead>
					<tbody {...getTableBodyProps()}>
						{/* {rows.map((row, i) => {
					prepareRow(row);
					return (
						<tr {...row.getRowProps()}>
							{row.cells.map((cell) => {
								return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
							})}
						</tr>
					);
				})} */}
						{page.map((row, i) => {
							prepareRow(row);
							return (
								<tr {...row.getRowProps()}>
									{row.cells.map((cell) => {
										return (
											<td {...cell.getCellProps()}>{cell.render('Cell')}</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>

			{!paginationNotRequired && (
				<div className='pagination'>
					<button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
						{'<<'}
					</button>{' '}
					<button onClick={() => previousPage()} disabled={!canPreviousPage}>
						{'<'}
					</button>{' '}
					<button onClick={() => nextPage()} disabled={!canNextPage}>
						{'>'}
					</button>{' '}
					<button
						onClick={() => gotoPage(pageCount - 1)}
						disabled={!canNextPage}>
						{'>>'}
					</button>{' '}
					<span>
						Page{' '}
						<strong>
							{pageIndex + 1} of {pageOptions.length}
						</strong>{' '}
					</span>
					{/* <span>
					| Go to page:{' '}
					<input
						type='number'
						defaultValue={pageIndex + 1}
						onChange={(e) => {
							const page = e.target.value ? Number(e.target.value) - 1 : 0;
							gotoPage(page);
						}}
						style={{ width: '100px' }}
					/>
				</span>{' '} */}
					{/* <select
					value={pageSize}
					onChange={(e) => {
						setPageSize(Number(e.target.value));
					}}>
					{[10, 20, 30, 40, 50].map((pageSize) => (
						<option key={pageSize} value={pageSize}>
							Show {pageSize}
						</option>
					))}
				</select> */}
				</div>
			)}
		</>
	);
}
export default Table;
